/**
 * RNC — role-gating helpers.
 *
 * Per modules digest §RNC (post role-schema rework 2026-04-27):
 *   - SuperAdmin: full access (templates, rate limits, delivery log viewer).
 *   - Supervisor / Manager: read-only (delivery log + rate-limit status).
 *   - All others: redirect.
 *
 * Note: legacy `Compliance` editor access has been removed — Risk reviewers
 * now work in the dedicated risk-mgmt-panel app, not in ROP-Teams.
 */
import type { UserRole } from '@retail-ops/shared-types/enums';

export const RNC_EDITOR_ROLES: ReadonlyArray<UserRole> = ['SuperAdmin'];
export const RNC_READ_ROLES: ReadonlyArray<UserRole> = [
  'SuperAdmin',
  'Supervisor',
  'Manager',
];

export function canEditRnc(role: UserRole | undefined): boolean {
  return role ? RNC_EDITOR_ROLES.includes(role) : false;
}

export function canReadRnc(role: UserRole | undefined): boolean {
  return role ? RNC_READ_ROLES.includes(role) : false;
}
